<template>
  <ed-input-item :label="label" :info="info" :name="name" :required="required">
    <p class="mt-5">
      <ckeditor
        :id="id"
        :value="value"
        :config="editorConfig"
        :disabled="disabled"
        :read-only="readonly"
        tag-name="textarea"
        :editor-url="editorUrl"
        @input="$emit('input', $event)"
      />
    </p>
  </ed-input-item>
</template>

<script>
import EdFormMixin from "./mixins/formControl";
import EdInputItem from "./EdInputItem";

export default {
  name: "EdInputEditor",
  mixins: [EdFormMixin],
  components: { EdInputItem },
  props: {
    type: {
      type: String,
      required: false,
      default: "text",
    },
  },
  data() {
    return {
      id: "ckeditor-" + this.$utilidade.randomString(),
      editorUrl:
        process.env.URL_CS +
        "/0.recursos/ckeditor_447_full/ckeditor.js?v=" +
        this.$root.$session.getCookie("version"),
      editorConfig: {
        language: "pt-br",
      },
    };
  },
  beforeDestroy() {},
  created() {},
  mounted() {
    this.inicialize();
  },
  computed: {},
  methods: {
    inicialize() {},
  },
};
</script>


// WEBPACK FOOTER //
// EdInputEditor.vue?a1274df0